<header class="header {{classCustom}}" #header>
    <div class="topo">
        <modulo class="logo-content" posicao="logo"></modulo>
        <div class="topo-content">
            <btn-cart [classCustom]="classCustom"></btn-cart>  
            <menu-partial template="mobile"></menu-partial>
        </div>
    </div>    
    <div class="content">
        <div class="container">
            <div class="row">
                <div class="col-md-2">
                    <div class="container-logo wow slideInDown" data-wow-delay="0.5s">
                        <modulo class="logo-content" posicao="logo"></modulo>
                    </div>
                </div>
                <div class="col-md-10 col-menu">
                    <div class="box-item">
                        <btn-usuario-login [classCustom]="classCustom" *ngIf="lojaAtivo"></btn-usuario-login>
                    </div>
                    <div class="box-item">
                        <btn-cart [classCustom]="classCustom"></btn-cart>  
                    </div>
                </div>    
            </div> 
            <div class="content-menu">
                <menu-partial [classCustom]="classCustom"></menu-partial>
            </div>
        </div>     
    </div>   
</header>  
